document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const prefersReduced = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
    ).matches;

    const sections = gsap.utils.toArray("section");

    if (prefersReduced) {
        gsap.set("[data-fade], h2, .section-heading", { opacity: 1, y: 0 });
        return;
    }

    sections.forEach(section => {
        // Collect all elements that should animate:
        // - any [data-fade] (including h2[data-fade])
        // - h1, and .section-heading
        // Using a Set to avoid duplicates if an h2 has both data-fade and matches another selector
        const itemsSet = new Set([
            ...section.querySelectorAll("[data-fade]"),
            ...section.querySelectorAll("h1"),
            ...section.querySelectorAll("h2"),
            ...section.querySelectorAll(".section-heading")
        ]);

        const items = Array.from(itemsSet);

        if (!items.length) return;

        // Hide initially (JS-loaded safe)
        gsap.set(items, { opacity: 0, y: 60 });

        ScrollTrigger.batch(items, {
            start: "top 80%",
            once: true,
            // markers: true,

            onEnter: batch => {
                gsap.to(batch, {
                    opacity: 1,
                    y: 0,
                    duration: 0.3,
                    ease: "power2.out",
                    stagger: 0.2,
                    overwrite: true
                });
            }
        });
    });

    // One-time measurement at load (page is at the top here, so it can't move
    // the scroll position).
    // ScrollTrigger.refresh(true);
});


document.addEventListener("DOMContentLoaded", () => {
  initGlobalStaggerHover();
});

// Shopify Theme Editor support — re-init when sections reload
document.addEventListener("shopify:section:load", () => {
  initGlobalStaggerHover();
});

function initGlobalStaggerHover() {
  const elements = document.querySelectorAll("a, button");

  elements.forEach((el) => {
    if (el.hasAttribute("data-flexype-button")) return;
    // Skip if already initialized
    if (el.dataset.staggerInitialized === "true") return;

    // Opt-out: add [data-no-stagger] to any <a>/<button> — or to a wrapper
    // around them (e.g. a mega-menu or a link with a badge) — to exclude it
    // (and everything inside it) from the global stagger hover animation.
    if (el.closest("[data-no-stagger]")) return;

    // Skip if no visible text
    const text = el.textContent.trim();
    if (!text) return;

    // Find the actual target to animate (the element or its inner span)
    const target = resolveAnimationTarget(el);
    if (!target) return;

    // Add data attributes + class to the OUTER element (<a> or <button>)
    el.setAttribute("data-staggering-animation", "");
    el.setAttribute("data-duration", "300");
    el.setAttribute("data-amount", "200");
    el.classList.add("global-animation-btn");

    setupStaggerAnimation(target, el);
  });
}

function resolveAnimationTarget(el) {
  const children = Array.from(el.childNodes);

  // Case 1: element contains only text → animate the element itself
  const onlyText = children.every((n) => n.nodeType === Node.TEXT_NODE);
  if (onlyText) return el;

  // Case 2: element contains a single <span> with only text inside
  // (whitespace text nodes around the span are okay)
  const elementChildren = children.filter(
    (n) => n.nodeType === Node.ELEMENT_NODE
  );
  const nonEmptyTextNodes = children.filter(
    (n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== ""
  );

  if (
    elementChildren.length === 1 &&
    elementChildren[0].tagName === "SPAN" &&
    nonEmptyTextNodes.length === 0
  ) {
    const span = elementChildren[0];
    const spanHasOnlyText = Array.from(span.childNodes).every(
      (n) => n.nodeType === Node.TEXT_NODE
    );
    if (spanHasOnlyText && span.textContent.trim() !== "") {
      return span;
    }
  }

  // Anything else (icons, multiple children, nested markup) → skip
  return null;
}

function setupStaggerAnimation(target, outerEl) {
  const computedStyle = getComputedStyle(target);
  const fontSize = parseFloat(computedStyle.fontSize);
  const computedLineHeight = computedStyle.lineHeight;
  const lineHeightPx =
    computedLineHeight === "normal"
      ? fontSize * 1.2
      : parseFloat(computedLineHeight);
  const animationDistance = lineHeightPx / fontSize; // in em

  const letters = buildChar(target, animationDistance, outerEl);
  if (letters.length === 0) return;

  target.innerHTML = "";

  const wrapper = document.createElement("span");
  wrapper.classList.add("global-animation-btn-inner");
  wrapper.style.display = "flex";
  wrapper.style.overflow = "clip";
  wrapper.style.lineHeight = "1";

  // If outer element has min-width or max-width, center the inner wrapper
  const outerStyle = getComputedStyle(outerEl);
  const minWidth = outerStyle.minWidth;
  const maxWidth = outerStyle.maxWidth;
  const hasMinWidth =
    minWidth !== "0px" && minWidth !== "auto" && minWidth !== "none";
  const hasMaxWidth = maxWidth !== "none";

  if (hasMinWidth || hasMaxWidth) {
    wrapper.style.alignItems = "center";
    wrapper.style.justifyContent = "center";
    wrapper.style.width = "100%";
    wrapper.style.height = "100%";
  }

  target.append(wrapper);
  wrapper.append(...letters);

  // Hover listeners go on the OUTER element so the whole button is hoverable
  outerEl.addEventListener("mouseenter", () => {
    letters.forEach((letter) => {
      letter.style.transform = `translateY(-${animationDistance}em)`;
    });
  });

  outerEl.addEventListener("mouseleave", () => {
    letters.forEach((letter) => {
      letter.style.transform = "translateY(0)";
    });
  });

  outerEl.dataset.staggerInitialized = "true";
}

function buildChar(target, lineHeight, outerEl) {
  const text = target.textContent.trim();
  if (!text) return [];

  // Read data attributes from the outer element (where we set them)
  const each = outerEl.dataset.each ? parseInt(outerEl.dataset.each) : 0;
  const amount = each ? 0 : parseInt(outerEl.dataset.amount) || 0;
  const duration = parseInt(outerEl.dataset.duration) || 800;
  const totalChars = text.length;
  const ms = each + amount === 0 ? 80 : each || amount;
  const delayPerChar = ms / (totalChars - 1 || 1);

  return [...text].map((char, index) => {
    const offsetDelay = delayPerChar * index;
    return createChar(char, offsetDelay, lineHeight, duration);
  });
}

function createChar(char, delay, lineHeight, duration) {
  const span = document.createElement("span");
  span.textContent = char === " " ? "\u00A0" : char;
  span.style.display = "inline-block";
  span.style.transition = `transform ${duration}ms cubic-bezier(0.625, 0.05, 0, 1) ${delay}ms`;
  span.style.textShadow = `0px ${lineHeight}em currentColor`;
  return span;
}